/**************
 Product Swiper
 **************/

    // setup single swiper
const productSwiper = new Swiper(document.querySelector(".productGiftVisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: true,
        zoom: {
            maxRatio: 2,
        }
    });

/****************
 Product Variants
 ***************/

// update active variant on input changes
document.querySelectorAll("#productGift input").forEach(function (element) {
    element.addEventListener("change", updateProduct);
})

// update active variant
function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productGiftOptionItem`).forEach(group => {
        options.push(group.querySelector(`input:checked`).value);
    });

    // find new variant based on the options
    activeVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options);
    });

    // update the product form
    document.querySelector('#productForm input[name="id"]').value = activeVariant.id;

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// checkout
document.querySelector('#productForm').addEventListener('submit', async function (e) {
    // prevent reloading page
    e.preventDefault();
    // add loading
    document.querySelector('#productGiftATC').classList.add('loading');
    const formData = new FormData(this);
    try {
        // using default shopify atc
        await fetch(`${Shopify.routes.root}cart/add.js`, {
            body: formData,
            method: "POST",
            headers: {},
        });
    } catch (err) {
        console.error(err);
        // remove loading
        document.querySelector('#productGiftATC').classList.remove('loading');
        return;
    }
    // remove loading
    document.querySelector('#productGiftATC').classList.remove('loading');
    // open the cart
    await openCart();
})